var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 5.83337L8.97073 10.5962C9.5217 10.9819 9.79719 11.1748 10.0968 11.2495C10.3615 11.3154 10.6384 11.3154 10.9031 11.2495C11.2027 11.1748 11.4782 10.9819 12.0292 10.5962L18.8333 5.83337M6.16663 16.6667H14.8333C16.2334 16.6667 16.9335 16.6667 17.4683 16.3942C17.9387 16.1545 18.3211 15.7721 18.5608 15.3017C18.8333 14.7669 18.8333 14.0668 18.8333 12.6667V7.33337C18.8333 5.93324 18.8333 5.23318 18.5608 4.6984C18.3211 4.22799 17.9387 3.84554 17.4683 3.60586C16.9335 3.33337 16.2334 3.33337 14.8333 3.33337H6.16663C4.76649 3.33337 4.06643 3.33337 3.53165 3.60586C3.06124 3.84554 2.67879 4.22799 2.43911 4.6984C2.16663 5.23318 2.16663 5.93324 2.16663 7.33337V12.6667C2.16663 14.0668 2.16663 14.7669 2.43911 15.3017C2.67879 15.7721 3.06124 16.1545 3.53165 16.3942C4.06643 16.6667 4.76649 16.6667 6.16663 16.6667Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4e571e0990ee169a6722289d16b7cd63.svg";
export { ForwardRef as ReactComponent };